import { useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import { observer, inject } from 'mobx-react';
import ArticleGroupStore from '../stores/articleGroupStore';
import { AuthStore, Authenticator, Secured, AppList } from '@vaettyr/boltcave-auth-client';
import { modalService, stringHelpers } from '@vaettyr/boltcave-client-core'
import EditGroups from './EditGroups';

type NavProps = {
  articlegroupstore?: ArticleGroupStore,
  authstore?: AuthStore,
  modalservice?: modalService
};


export default
  inject('articlegroupstore', 'authstore', 'modalservice' )(observer(
    ({articlegroupstore, modalservice, authstore}:NavProps) => {

      useEffect(() => {
        articlegroupstore?.GetGroups();
      }, [authstore?.authenticated]);

      const { pathname = "/" } = useLocation();
      const { authenticated = false } = authstore ?? {};
      const { groups = [] } = articlegroupstore ?? {};
      const trimmed = pathname?.substring(1) ?? "";
      const groupName = trimmed.indexOf('/') > 0 ? trimmed.substring(0, trimmed.indexOf('/') ) : trimmed;

      const activePage = groupName.length > 0 ? groupName : ( groups.length > 0 ? (stringHelpers.prettyEncodeUri( groups[0].name ) ?? "") : "" );

      function linkClass(group:string):string {
        return group === activePage ? "navbar-item is-active" : "navbar-item";
      }

      function editGroups() {
        modalservice?.show({
          body:<EditGroups/>,
          options: {className:'edit-groups'},
          key:'edit-groups'
        });
      }

      return (
        <nav className="navbar" role="navigation" aria-label="main-navigation">
          <div className="navbar-brand">
            <div className="navbar-item">
                <AppList fill={ authenticated ? "#fff" : " #011" }/>
                <p className="title">The Boltcave</p>
            </div>
          </div>

          <div className="navbar-menu">
            <div className="navbar-start">
              {groups.length && groups.map((group, i) => {
                const groupname = stringHelpers.prettyEncodeUri(group.name) ?? "";
                return(
                  <Link className={linkClass(groupname)} key={groupname} to={"/" + groupname}>{group.name}</Link>
                );
              })}
              <Secured claims={[{key:"ENUM.ArticleGroupService.CanEditGroups", value:"ALL"}]}>
                <span className="icon clickable" onClick={editGroups} data-tooltip="Edit Groups">
                    <i className="fa-solid fa-pen-to-square"></i>
                </span>
              </Secured>
            </div>
          </div>

          <div className="navbar-end">
            <Authenticator types={["google"]}/>
          </div>
        </nav>
      );
    }
  )
);